(() => {
  const buttons = [...document.querySelectorAll('[data-privacy-preferences]')];
  if (!buttons.length) return;
  const reveal = () => {
    if (typeof window.privacyBanner?.showPreferences !== 'function') return false;
    buttons.forEach(button => { button.hidden = false; });
    return true;
  };
  buttons.forEach(button => button.addEventListener('click', async () => {
    button.disabled = true;
    try {
      await window.privacyBanner.showPreferences();
    } catch {
      const message = button.parentElement.querySelector('[data-privacy-error]');
      if (message) message.hidden = false;
    } finally {
      button.disabled = false;
    }
  }));
  if (!reveal()) window.addEventListener('load', reveal, { once: true });
})();
